import { Component, OnInit, Input, Output, SimpleChanges, ViewChild, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { MatDialog, MatSnackBar, MatSort, MatPaginator, MatTableDataSource } from '@angular/material';
import { PortfolioService } from 'src/app/services/portfolio/portfolio.service';
import { FilterService } from 'src/app/services/filter.service';
import { AddSessionModalComponent } from '../add-session-modal/add-session-modal.component';
import * as _ from 'lodash'
import { QuizService } from 'src/app/services/quiz.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilityService } from '../../services/utility.service'

@Component({
  selector: 'app-sessions',
  templateUrl: './sessions.component.html',
  styleUrls: ['./sessions.component.scss']
})
export class SessionsComponent implements OnInit {
  user: any;
  sort: MatSort;
  paginator: MatPaginator;
  displayedColumns: string[] = ['title'];
  dataSource: MatTableDataSource<any>;
  filterActive: Boolean = false;
  noDataMsg = {
    title: "No Titles!",
    data: "You have not yet added any Titles"
  }
  afterFilter: any;
  allSessionsCopy: any;
  loading: boolean;

  selectedMaterial: any;
  quizzes: any;
  sessionId: any;
  sessionType: any;
   

  @ViewChild(MatSort, { static: true }) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }
  @ViewChild(MatPaginator, { static: true }) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }
  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  @Input('course') course;
  @Output() openFilesSideNav: EventEmitter<any> = new EventEmitter<any>();

  portfolio: any;
  allSessions: any;
  sessionTitle
  learnerId
  jobId
  constructor(public dialog: MatDialog, public _snackBar: MatSnackBar, public _portfolioService: PortfolioService,
    public _filter: FilterService, public _quizService: QuizService, public activatedRoute: ActivatedRoute, private router: Router,  public _utilityService: UtilityService) {
    this.dataSource = new MatTableDataSource(this.portfolio);    
  }

  ngOnInit() {
    this.loading = true
    this.user = JSON.parse(localStorage.getItem('userRoles'))
    console.log("this.user s ==========>", this.user)
    // this.getSessions()
    this.activatedRoute.queryParams.subscribe(qparam => {
      console.log("QUREY PARAMS ARE", qparam)
      if (qparam.sessionId) {
        this.sessionId = qparam.sessionId
      }
      if (qparam.sessionType) {
        this.sessionType = qparam.sessionType
      }
      if (qparam.learnerId) {
        this.learnerId = qparam.learner
      }
      if (qparam.jobId) {
        this.jobId = qparam.jobId
      }
      this.getQuizzes()
    })
  }
  ngOnChanges(changes: SimpleChanges): void {
    console.log("CHANGES ==========>>>>>>>>>>>", changes);
    if (changes && changes.course) {
      this.course = changes.course.currentValue
      // this.getSessions()
    }
  }


  addSessionsModal() {
    let data = {
      session: true,
      course: this.course,
    }
    this.openDialog(AddSessionModalComponent, data).subscribe(res => {
      console.log('res in sessions tab', res)
      if (!res) return
      else {
        this.allSessions.push(res)
        this.allSessionsCopy = JSON.parse(JSON.stringify(this.allSessions))
        this.updateData(this.allSessions)
        this.openSnackBar('Session Added Successfully!', 'Ok')
      }
    })
  }

  deletedSession(event) {
    console.log('event', event)
    let index = _.findIndex(this.allSessions, function (o) { return o._id == event._id })
    if (index > -1) {
      this.allSessions.splice(index, 1)
      this.allSessionsCopy = JSON.parse(JSON.stringify(this.allSessions))
      this.updateData(this.allSessions)
      this.openSnackBar('Session Deleted Successfully!', 'Ok')
    }
  }

  applyFilter(searchText) {
    this.afterFilter = null
    this.filterActive = true;
    if (searchText === '') {
      this.updateData(this.allSessionsCopy);
      this.filterActive = false;
    }
    let filteredLearner = this._filter.filter(searchText, this.allSessions, ['title']);
    this.updateData(filteredLearner);
    if (filteredLearner.length <= 0) {
      this.afterFilter = {
        title: "No Titles!",
        data: "No titles with matched search text found!"
      }
    }
  }

  fileDetailsComp(event) {
    console.log("fileDetailsComp", event);
    this.openFilesSideNav.emit({ event })
  }

  loadSessionFiles(event) {

    this.selectedMaterial = event.materialId;
  }

  redirectToQuiz(quiz) {
    this.activatedRoute.paramMap.subscribe(param => {
      console.log("paramMaps----------", param)
      // this.jobId = param.jobid
    })
    this.activatedRoute.queryParamMap.subscribe((param: any) => {
      console.log("queryParamMap----------", param)
      //if (param.learnerId || param.learner) {
      //    this.router.navigate(['/appear-quiz'], { queryParams: { quizId: quiz, learnerId: this.learnerId } })
      //} else {
      //    this.router.navigate(['/create-quiz'], { queryParams: { quizId: quiz } })
      //}
    })

    if (this.activatedRoute.snapshot.queryParams.learnerId) {
      console.log('IN IFFFFFFF')
      this.router.navigate(['/appear-quiz'], { queryParams: { quizId: quiz, learnerId: this.activatedRoute.snapshot.queryParams.learnerId, jobId: this.jobId } })
    } else {
      console.log('in elsee')
      this.router.navigate(['/create-quiz'], { queryParams: { quizId: quiz } })
    }
    console.log("what is the current user", this.user);
    //this.user && this.user.isLearner
    console.log("learner If is,", this.learnerId)
    // if (this.learnerId) {
    //  this.router.navigate(['/appear-quiz'], { queryParams: { quizId: quiz, learnerId: this.learnerId } })
    //} else {
    //  this.router.navigate(['/create-quiz'], { queryParams: { quizId: quiz } })
    //}
  }


  // UTILITY
  getRandomColorClass(i) {
    return this._utilityService.getCommonRandomColorClass(i)
  }
  updateData(data) {
    console.log("UPDATING DATA = ", data)
    console.log("Emitting event getLearnersFromComponent with learners = ", data);
    this.dataSource = new MatTableDataSource(data);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    console.log("SETTING SORT TO = ", this.dataSource.sort)
    console.log("SETTING paginator TO = ", this.dataSource.paginator)
    // this.loading = false;

  }
  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, { data });
    return dialogRef.afterClosed();
  }


  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  // API calls
  getSessions() {
    console.log('THIS.COURSE', this.course)
    if (this.course) {
        this._portfolioService.getSessions(this.course.portfolioId, undefined, this.jobId).subscribe(res => {
        console.log("resss", res[0]);
        this.portfolio = res[0]
        let userRole = JSON.parse(localStorage.getItem('userRoles'))

        this.allSessions = this.portfolio.classRoomSessions.concat(this.portfolio.practicalSessions)
        console.log("all sessoing list with concat", this.allSessions);
        console.log("this user =====++>", userRole);
        // if(this.user.isLearner || this.user.isTrainer){
        this.allSessions = this.allSessions.filter((singleSession) => {
          if (singleSession.quizId && singleSession.quizId.length > 0) {
            return singleSession;
          }
        });
        // }
        this.allSessionsCopy = this.portfolio.classRoomSessions.concat(this.portfolio.practicalSessions)
        // if(this.user.isLearner || this.user.isTrainer){
        this.allSessionsCopy = this.allSessionsCopy.filter((singleSession) => {
          if (singleSession.quizId && singleSession.quizId.length > 0) {
            return singleSession;
          }
        });

        const index = this.allSessions.findIndex(x => x.title == 'Tools & Equipment');
        console.log("index of tools and quipment", index);

        let oneQuiz = this.allSessions.filter((o) => {
          return o.title == 'Tools & Equipment'
        })
        console.log("what is single quiz to remove", oneQuiz);
        let quizArray = oneQuiz[0].quizId

        // let id1 = "5f532e54695868276179af47"
        // console.log("index value==========", index);
        quizArray.splice("5f532e54695868276179af47", 1)

        quizArray.splice("5f532629695868276179af37", 1)

        quizArray.splice("5f532abe695868276179af3e", 1)
        console.log("array===========", quizArray);
        // }

        this.updateData(this.allSessions)
        this.loading = false
      })
    }
  }


  editFromTile(event) {
    console.log("event of update session", event);
    console.log("what is all sessions details after edit", this.allSessions);
    let findIndex = this.allSessions.findIndex(x => x._id === event._id);
    let obj = {
      _id: event._id,
      files: this.allSessions[findIndex].files,
      quizId: this.allSessions[findIndex].quizId,
      title: event.title,
      sessionType: event.sessionType,
      course: event.course,
      portfolioId: event.portfolioId,
      createdAt: event.createdAt,
      updatedAt: event.updatedAt
    }
    this.allSessions[findIndex] = obj
    this.updateData(this.allSessions)

  }
  getQuizzes() {
    console.log("this.sessionId", this.sessionId, "this.sessionType", this.sessionType)
    if (this.sessionId && this.sessionType) {
      this._quizService.getQuizzes(this.sessionId, this.sessionType).subscribe(res => {
        console.log("in material tile getting quizzez", res)
        this.quizzes = res
        this.sessionTitle = this.quizzes[0].sessionId.title
        console.log("whataa is the title of session", this.sessionTitle);

      })
    }
  }
}


// assignmentNo: 1
// course: "5f101e8fbf3db024498349a7"
// createdAt: "2020-07-17T10:37:29.919Z"
// files: []
// title: "Test 1"
// type: "Reading"
// unitNo: 1
// updatedAt: "2020-07-17T10:37:29.919Z"
// __v: 0
// _id: "5f117f69f9736271df550013"